webpackJsonp([58995536736497],{

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/divider4.c64873de.jpg";

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(40);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _sortBy = __webpack_require__(44);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactObfuscate = __webpack_require__(109);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _divider = __webpack_require__(180);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* https://www.npmjs.com/package/react-obfuscate */
	
	var HeaderComplete = function (_React$Component) {
		_inherits(HeaderComplete, _React$Component);
	
		function HeaderComplete() {
			_classCallCheck(this, HeaderComplete);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		HeaderComplete.prototype.render = function render() {
			// console.log("props", this.props)
			// const pageLinks = []
			// const site = get(this, 'props.data.site.siteMetadata')
			return _react2.default.createElement(
				'div',
				{ id: 'headerwrap', name: 'home', style: { backgroundImage: 'url(' + _divider2.default + ')' } },
				_react2.default.createElement(
					'header',
					{ className: 'clearfix' },
					_react2.default.createElement(
						'h1',
						null,
						_react2.default.createElement('span', { className: 'icon icon-w' })
					),
					_react2.default.createElement(
						'p',
						null,
						'Christian Wolter'
					)
				)
			);
		};
	
		return HeaderComplete;
	}(_react2.default.Component);
	
	var Footer = function (_React$Component2) {
		_inherits(Footer, _React$Component2);
	
		function Footer() {
			_classCallCheck(this, Footer);
	
			var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
			_this2.state = {
				intervalId: 0
			};
			return _this2;
		}
	
		Footer.prototype.scrollStep = function scrollStep() {
			if (window.pageYOffset === 0) {
				clearInterval(this.state.intervalId);
			}
			window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
		};
	
		Footer.prototype.scrollToTop = function scrollToTop() {
			var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
			this.setState({ intervalId: intervalId });
		};
	
		Footer.prototype.render = function render() {
			var _this3 = this;
	
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ id: 'footerwrap' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'h4',
							null,
							_react2.default.createElement(
								'small',
								null,
								'created by Christian Wolter - copyright 2019 - ',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/imprint', onClick: function onClick() {
											_this3.scrollToTop();
										} },
									'imprint | disclaimer'
								),
								' -  ',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/privacy', onClick: function onClick() {
											_this3.scrollToTop();
										} },
									'privacy'
								)
							)
						)
					)
				)
			);
		};
	
		return Footer;
	}(_react2.default.Component);
	
	var ScrollButton = function (_React$Component3) {
		_inherits(ScrollButton, _React$Component3);
	
		function ScrollButton() {
			_classCallCheck(this, ScrollButton);
	
			var _this4 = _possibleConstructorReturn(this, _React$Component3.call(this));
	
			_this4.state = {
				intervalId: 0
			};
			return _this4;
		}
	
		ScrollButton.prototype.scrollStep = function scrollStep() {
			if (window.pageYOffset === 0) {
				clearInterval(this.state.intervalId);
			}
			window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
		};
	
		ScrollButton.prototype.scrollToTop = function scrollToTop() {
			var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
			this.setState({ intervalId: intervalId });
		};
	
		ScrollButton.prototype.render = function render() {
			var _this5 = this;
	
			return _react2.default.createElement(
				'button',
				{ title: 'Back to top', className: 'scroll',
					onClick: function onClick() {
						_this5.scrollToTop();
					} },
				_react2.default.createElement('span', { className: 'arrow-up glyphicon glyphicon-chevron-up' })
			);
		};
	
		return ScrollButton;
	}(_react2.default.Component);
	
	var Projects = function (_React$Component4) {
		_inherits(Projects, _React$Component4);
	
		function Projects() {
			_classCallCheck(this, Projects);
	
			return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
		}
	
		Projects.prototype.render = function render() {
			var pathPrefix =  false ? '' : ("");
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(HeaderComplete, null),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'container', id: 'impressum', name: 'impressum' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'h1',
								{ className: 'centered' },
								'imprint'
							),
							_react2.default.createElement('hr', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4' },
								_react2.default.createElement(
									'h3',
									{ id: 'impressum' },
									'imprint'
								),
								_react2.default.createElement(
									'p',
									null,
									'Information pursuant to \xA7 5 TMG ',
									_react2.default.createElement(
										'small',
										null,
										'(german telemedia act)'
									),
									':',
									_react2.default.createElement('br', null),
									'Christian Wolter',
									_react2.default.createElement('br', null),
									'Poppenreutherstr. 49a',
									_react2.default.createElement('br', null),
									'90419 N\xFCrnberg',
									_react2.default.createElement('br', null)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4' },
								_react2.default.createElement(
									'h3',
									null,
									'responsible for the content:'
								),
								_react2.default.createElement(
									'p',
									null,
									'According to \xA7 55 Abs. 2 RStV:',
									_react2.default.createElement('br', null),
									'Christian Wolter',
									_react2.default.createElement('br', null),
									'Poppenreutherstr. 49a',
									_react2.default.createElement('br', null),
									'90419 N\xFCrnberg',
									_react2.default.createElement('br', null)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-4' },
								_react2.default.createElement(
									'h3',
									null,
									'contact:'
								),
								_react2.default.createElement(
									'p',
									null,
									'Phone: ',
									_react2.default.createElement(
										'em',
										null,
										'please ask for my phone number via email'
									),
									_react2.default.createElement('br', null),
									'Mail: ',
									_react2.default.createElement(_reactObfuscate2.default, {
										email: 'contact@christian-wolter.com',
										headers: { subject: 'Contact via webpage' } })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'h1',
								{ className: 'centered' },
								'disclaimer'
							),
							_react2.default.createElement('hr', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-12' },
								_react2.default.createElement(
									'h3',
									{ id: 'impressum' },
									'disclaimer - legal notice'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'\xA7 1 Warnings regarding content'
									)
								),
								_react2.default.createElement(
									'p',
									null,
									'The free and accessible content of this website has been created with the utmost care. However, the provider of this website does not guarantee the correctness and up-to-dateness of the free and freely available journalistic guides and messages. Contributions identified by name represent the opinion of the author and not always the opinion of the provider. By calling the free and freely accessible content, there is no contractual relationship between the user and the provider, in this respect there is a lack of the provider\'s legal commitment.'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'\xA7 2 External links'
									)
								),
								_react2.default.createElement(
									'p',
									null,
									'This website contains links to websites of third parties ("external links"). These websites are the responsibility of the respective operators. When the external links were linked for the first time, the provider checked the contents of third parties to ascertain whether there were any legal violations. At that time no legal violations were apparent. The provider has no influence on the current and future design and content of the linked pages. The setting of external links does not mean that the provider owns the content behind the link or link. A constant control of the external links is unreasonable for the provider without concrete indications of legal violations. In case of knowledge of legal violations, however, such external links are immediately deleted.'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'\xA7 3 Copyright and performance rights'
									)
								),
								_react2.default.createElement(
									'p',
									null,
									'The contents published on this website are subject to the German copyright and the right of protection. Any use not permitted by the German Copyright and Performance Protection Law requires the prior written consent of the provider or respective copyright owner. This applies in particular to duplication, editing, translation, storage, processing or reproduction of content in databases or other electronic media and systems. Contents and rights of third parties are marked as such. The unauthorized duplication or dissemination of individual contents or complete pages is not permitted and punishable. Only the production of copies and downloads for personal, private and non-commercial use is permitted.'
								),
								_react2.default.createElement(
									'p',
									null,
									'Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zul\xE4ssig.'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'strong',
										null,
										'\xA7 4 Special Conditions of Use'
									)
								),
								_react2.default.createElement(
									'p',
									null,
									'Insofar as special conditions for individual uses of this website deviate from the abovementioned paragraphs, this is explicitly pointed out at the appropriate place. In this case, the special conditions of use apply in the particular case.'
								),
								_react2.default.createElement(
									'p',
									null,
									_react2.default.createElement(
										'small',
										null,
										'Source: ',
										_react2.default.createElement(
											'a',
											{ href: 'http://www.juraforum.de/', target: '_blank' },
											'juraforum.de'
										)
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(ScrollButton, { scrollStepInPx: '50', delayInMs: '16.66' }),
				_react2.default.createElement(Footer, null)
			);
		};
	
		return Projects;
	}(_react2.default.Component);
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-imprint-index-jsx-8bf2b8764fe6b65160d2.js